import React, { useState } from 'react';
import { List } from 'antd';
import { useParams } from "react-router-dom";
import ModalVideo from 'react-modal-video';
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../../providers/AuthProvider";
import InterviewStepDetail from "./InterviewStepDetail";
import { useAPI } from "../../../config/API";
import LoadingSpinner from "../../../components/LoadingSpinner";
import ErrorBanner from "../../../components/ErrorBanner";
import SpinLoader from '../../../components/SpinLoader';
import { TalentAppCard } from '../components/TalentAppCard';


const TalentInterviewSteps = ({ children, ...props }) => {
    const [previewingVideo, setPreviewingVideo] = useState(null)
    const { auth, isUpdating, talentUpdate, update: updateAuth } = useAuth();
    const { currentStep, "*": other } = useParams();

    const {
        data: steps,
        error,
        refetch,
        isFetching,
    } = useAPI('fetchLatestVideoInterviewForTalent', {
        initialData: TB.map(TB.orderBy(laravel.talent_video_interview_steps || [], 'display_index', 'asc'), step => {
            let existingStep = TB.find(auth?.talent_video_interviews || [], ['step.id', step.id]);

            if (existingStep) {
                let {
                    step: stepInfo,
                    ...latest_interview
                } = existingStep;
                return {
                    ...step,
                    latest_interview
                }
            }
            return step;
        }),
        onSuccess: (data) => {
            console.log('onSuccess', data)
        },
        onError: (error) => {
            console.log('onError', error)
        }
    })


    const uploadTalentVideoMutation = useMutation(['uploadTalentVideo', props.talent?.id], async ({ fileUploaded, step }) => {
        const uploadTalentVideoRrequest = TB.request(TB.api_endpoint(`/api/talent/video-interviews/${step.id}/store`), { video: fileUploaded }).headers({ 'Content-Type': 'multipart/form-data' });
        const uploadResponse = await uploadTalentVideoRrequest.post().catch(console.warn);

        if (!uploadResponse.success) {
            throw new Error('Something went wrong!');
        }

        const updates = await auth.updateTalentVideoInterviewSteps(uploadResponse.success.data.steps);

        await props.onChange(updates);
    }, {
        onSuccess: async (response) => {
            return TB.toast('Video Interviews Updated')
        },
        onError: async (error) => {
            console.error("uploadTalentVideoMutation", error)
            return TB.showServerErrorToast()
        }
    })

    return (
        <React.Fragment>
            {children}

            {isFetching ? (
                <div className="flex flex-col p-8 flex-grow items-center justify-center">
                    <LoadingSpinner size="lg" />
                </div>
            ) : (error ? (
                <ErrorBanner
                    title="Something went wrong"
                    message="Unable to load talent. Please try again later"
                    onRetry={refetch} />
            ) : (
                <React.Fragment>
                    <SpinLoader isLoading={uploadTalentVideoMutation?.isLoading} className="flex flex-col items-stretch">

                        <List itemLayout="vertical" dataSource={steps} renderItem={(item, index) => (
                            // <List.Item className="border-t first:border-t-0 py-4">
                            <List.Item className="">
                                <TalentAppCard.Section>
                                    <InterviewStepDetail
                                        isActive={parseInt(currentStep) === item.display_index}
                                        step={item}
                                        onUploadVideo={step => uploadTalentVideoMutation.mutate(step)}
                                        {...props}
                                        isDisabled={props.isDisabled || uploadTalentVideoMutation?.isLoading}
                                        onPreview={setPreviewingVideo}
                                    />
                                </TalentAppCard.Section>
                            </List.Item>
                        )} />
                        <ModalVideo
                            channel="custom"
                            url={previewingVideo}
                            isOpen={!!previewingVideo}
                            onClose={() => setPreviewingVideo(false)}
                        />
                    </SpinLoader>

                </React.Fragment>
            ))}
        </React.Fragment>
    )
};

export default TalentInterviewSteps;